// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hitmonlee: PokeData = {
  "id": 106,
  "name": "hitmonlee",
  "height": 15,
  "weight": 498,
  "base_experience": 159,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "double-kick",
    "mega-kick",
    "jump-kick",
    "rolling-kick",
    "tackle",
    "low-kick",
    "meditate",
    "focus-energy",
    "high-jump-kick",
    "mind-reader",
    "reversal",
    "foresight",
    "endure",
    "fake-out",
    "facade",
    "helping-hand",
    "revenge",
    "brick-break",
    "blaze-kick",
    "feint",
    "close-combat",
    "sucker-punch",
    "wide-guard",
    "low-sweep",
    "axe-kick"
  ],
  "moves": [
    "double-kick",
    "jump-kick",
    "rolling-kick",
    "tackle",
    "blaze-kick",
    "close-combat",
    "drain-punch",
    "superpower",
    "vacuum-wave",
    "coaching",
    "bulk-up",
    "meteor-assault",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 47,
    "item": null,
    "species": [
      {
        "name": "tyrogue",
        "order": 115,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hitmonlee",
        "order": 116,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmonchan",
        "order": 117,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": -1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmontop",
        "order": 118,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 0,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 128,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
